import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const Label = styled(Text)`
    font-size: 14px;
    color: #919191;
`;

export const Note = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
        color: yellow;
    }

    @media (${theme.breakpoints.mobileL}) {
        svg {
            transform: scale(1.8);
            margin-right: 5px;
        }
    }
`;
